import Text from 'components/Text/Text';
import './StepTitle.scss';

import {postGeneratorSteps} from '../typescript';

interface IStepTitleProps {
  step: string;
}

const StepTitle = ({step}: IStepTitleProps) => {
  const stepMapper: {[key: string]: string} = {
    [postGeneratorSteps.manageBeers]: 'Step 1: Select beers on your tap',
    [postGeneratorSteps.postType]: 'Step 2: Choose type of your post',
    [postGeneratorSteps.postTemplate]: 'Step 3: Modify your post',
  };

  return (
    <Text tag="h3" className="step-title">
      {stepMapper[step]}
    </Text>
  );
};

export default StepTitle;
